import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import database from './classes/database'
import helper from './classes/helper'
import kiosk from './classes/kiosk'

kiosk.router = router;

Vue.config.productionTip = false

Vue.prototype.$database = database;
Vue.prototype.$helper = helper;

window.addEventListener('DOMContentLoaded', function () {
    if (!('mediaDevices' in navigator &&
        'getUserMedia' in navigator.mediaDevices &&
        'Worker' in window)) {
        alert('Sorry, your browser is not compatible with this app.');
        return;
	}

	database.create().then(function(){
		new Vue({
			router,
			render: h => h(App)
		}).$mount('#app');

		window.addEventListener('online', helper.onlineChange);
		window.addEventListener('offline', helper.onlineChange);
		helper.onlineChange();

		helper.checkUpdate();

		kiosk.ping().catch(() => {});
		kiosk.flush().catch(() => {});
		helper.startPingTimer(kiosk);
		// Back online: send what waited, without waiting for the next scan.
		window.addEventListener('online', () => kiosk.flush().catch(() => {}));
	});
});

helper.startUnsendBadgesTimer();
helper.startCheckUpdateTimer();